import "./style/_index.scss";
export { Frame };
/**
 * Базовый фрейм предназначен для создания на его основе других фреймов
 * например, фрейма учебного продукта {@link ../product/ProductFrame.jsx}.
 *
 * Он подключает общие стили и устанавливает заголовок окна.
 * 
 * @summary Базовый фрейм.
 * @param {Object} props - Атрибуты элемента.
 * @param {string} props.title - Заголовок окна. 
 * @param {JSX.Element} props.children - Содержимое.
 * @returns {JSX.Element} Элемент JSX.
 * @example
 * <Frame title="Заголовок окна">Содержимое</Frame>
 * @author Алексей Васьковский <avaskovskiy@umney.ru>
 */
function Frame(
  {
    title,
    children
  }) {
  if (title) document.title = title;
  return children
}
